/**
 *
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
function CacheManager() {
  this.cache = {};
  this.fallback = {};
}

CacheManager.prototype = {
  get(url) {
    return this.cache[url];
  },

  getOrFallback(url) {
    if (this.cache[url] instanceof Promise) {
      return this.fallback[url];
    }
    return this.cache[url];
  },

  isFetching(url) {
    if (url in this.cache) {
      if (this.cache[url] instanceof Promise) {
        return this.cache[url];
      }

      return Promise.resolve(this.cache[url]);
    }
  },

  isReady(url) {
    return typeof this.cache[url] === "string";
  },

  /**
   *
   * @param {string} path
   * @param {number} [resolution]
   * @returns {Promise<string>|*|Promise<Awaited<*>>}
   */
  image(path, resolution) {
    const imageUrl = resolution ? `${path}.${resolution}` : path;
    const fetching = this.isFetching(imageUrl);
    if (fetching) {
      return fetching;
    }

    this.fallback[imageUrl] = `${path}.120`;

    return (this.cache[imageUrl] = fetch(imageUrl, {
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        Accept: "image/jpeg,*/*;q=0.8",
      },
    })
      .then((response) => response.arrayBuffer())
      .then((buffer) => {
        const blob = new Blob([buffer], { type: "image/jpeg" });
        return (this.cache[imageUrl] = URL.createObjectURL(blob));
      }));
  },

  async video(videoUrl) {
    const fetching = this.isFetching(videoUrl);
    if (fetching) {
      return fetching;
    }

    const response = await fetch(videoUrl, {
      mode: "cors",
    });

    if (!response.ok) {
      return null;
    }

    return (this.cache[videoUrl] = response.arrayBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: videoUrl.endsWith(".webm")
          ? "video/webm; codecs=vp9"
          : "video/mp4",
      });
      return (this.cache[videoUrl] = URL.createObjectURL(blob));
    }));
  },
};

export default CacheManager;
